import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NzFormLoadingModule } from './lib/nz-form-loading';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { ru_RU } from 'ng-zorro-antd/i18n';
import { CommonModule, registerLocaleData } from '@angular/common';
import ru from '@angular/common/locales/ru';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { LoggerModule } from './shared/services/logger';
import { environment } from '../environments/environment';
import { HttpResponseInterceptor } from './shared/interceptors/http-response.interceptor';
import { HttpAuthInterceptor } from './shared/interceptors/http-auth.interceptor';
import { HttpRequestMockInterceptor } from './shared/interceptors/http-request-mock.interceptor';
import { HttpRequestInterceptor } from './shared/interceptors/http-request.interceptor';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { AppRoutingModule } from './app-routing.module';

registerLocaleData(ru);

import { LayoutModule } from './layouts/layout.module';
import { RouterModule } from '@angular/router';
import { AuthModule } from './pages/auth/auth.module';
// Настройка прогресса
import { IconsProviderModule } from './icons-provider';
import { JournalModule } from './lib/journal';
import { provideNgxWebstorage, withNgxWebstorageConfig, withLocalStorage, withSessionStorage } from 'ngx-webstorage';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { GlobalErrorHandler } from './shared/services/analytics/error-handler';
import { HttpAnalyticsInterceptor } from './shared/services/analytics/http-analytics.interceptor';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    LoadingBarHttpClientModule,
    AppRoutingModule,
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // Модули NG-ZORRO
    IconsProviderModule,
    NzSpinModule,
    NzFormModule,
    NzButtonModule,
    NzCardModule,
    NzModalModule,
    NzUploadModule,
    NzEmptyModule,
    LayoutModule,
    AuthModule,
    JournalModule,
    NzFormLoadingModule,
    LoggerModule.forRoot(environment.logLevel),
  ],
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: NZ_I18N, useValue: ru_RU },
    //ngx-webstorage
    provideNgxWebstorage(
      withNgxWebstorageConfig({
        prefix: environment.prefixSession || 'ngx-webstorage',
        separator: '.',
        caseSensitive: true,
      }),
      withLocalStorage(),
      withSessionStorage(),
    ),

    // Настройка HTTP перехватчиков
    { provide: HTTP_INTERCEPTORS, useClass: HttpAnalyticsInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpResponseInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpAuthInterceptor, multi: true },
    environment.isMock ? { provide: HTTP_INTERCEPTORS, useClass: HttpRequestMockInterceptor, multi: true } : [],
    { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
